import React, { Component } from 'react';
import Label from '../../../../components/atoms/Label';
import LabelWithText from '../../../../components/molecules/LabelWithText';
import LabelWithBtn from '../../../../components/molecules/LabelWithBtn';
import curencyFormat from '../../../../utils/helpers/curencyFormat';
import dateFormatIndo from '../../../../utils/helpers/dateFormatIndo';

export default ({ title, infoCollateral }) => {
  let col = { label : 'col-md-3', text : 'col-md-9' }
  let { collateralType, collateralDetail, collateralDocuments } = infoCollateral
  return(
    <div>
        <Label value={title} className='label-menu'/>
        <div>
          <LabelWithText label = {'Tipe Jaminan'} text = {collateralType || "-"} col={col} />
          <LabelWithText label = {'Nomor Invois'} text = {collateralDetail.invoiceNumber ? collateralDetail.invoiceNumber : '-'} col={col} />
          <LabelWithText label = {'Nilai Invois'} text = {collateralDetail.invoiceAmount ? `Rp ${curencyFormat(collateralDetail.invoiceAmount)}` : '-'} col={col} />
          <LabelWithText label = {'Tanggal Invois'} text = {collateralDetail.invoiceIssueDate ? dateFormatIndo(collateralDetail.invoiceIssueDate, 'long') : '-'} col={col} />
          <LabelWithText label = {'Tanggal Jatuh Tempo Invois'} text = {collateralDetail.invoiceDueDate ? dateFormatIndo(collateralDetail.invoiceDueDate, 'long') : '-'} col={col} />
          <LabelWithText label = {'Nama Pembayar'} text = {collateralDetail.payorName ? collateralDetail.payorName : '-' } col={col} />
          {
            collateralDocuments.map(( value, index ) => {
              return(
                <LabelWithBtn key={index} label = {`Dokumen ${index + 1}`} col={col}url={ value.url }/>
              )
            })
          }
        </div>
    </div>
  )
}